import { type FC } from 'react';
import { useIntl, defineMessages, FormattedMessage } from 'dibs-react-intl';
import {
    useAuctionCountdown,
    countdownToText,
} from 'dibs-crypto-utils/exports/useAuctionCountdown.ts';

import styles from './styles/NftItemTileAuctionCountdown.scss';

const messages = defineMessages({
    countdownLabel: {
        id: 'cryptoUtils.auctionCountdown',
        defaultMessage: 'auction countdown',
    },
});

type Props = {
    endDate: string;
};

export const NftItemTileAuctionCountdown: FC<Props> = ({ endDate }) => {
    const intl = useIntl();
    const { countdownUnits, countdownFinished } = useAuctionCountdown(endDate);

    return (
        <span className={countdownUnits ? '' : styles.hidden}>
            {countdownFinished ? (
                <FormattedMessage id="nftItemTile.auction.ended" defaultMessage="Ended" />
            ) : (
                <FormattedMessage
                    id="nftItemTile.auction.endsIn"
                    defaultMessage="Ends in {countdown}"
                    values={{
                        countdown: (
                            <span
                                className={styles.bold}
                                aria-label={intl.formatMessage(messages.countdownLabel)}
                            >
                                {countdownUnits && countdownToText(countdownUnits)}
                            </span>
                        ),
                    }}
                />
            )}
        </span>
    );
};
